/** The member avatar pieces shared by the connected roster and the editor header's agent chip. */

export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]!.toUpperCase()).join('') || '·'
}

/** Stable colour from a name (matches the cursor/presence colour scheme). */
export function colorFromName(name: string): string {
  let h = 0
  for (const ch of name) h = (h * 31 + ch.charCodeAt(0)) % 360
  return `hsl(${h} 65% 45%)`
}

/**
 * Robot silhouette drawn BEHIND the initials — the avatar's "this member's console agent is
 * working" state. Same 31px footprint and the same initials at the same size as the round human
 * avatar, so only the shape changes and the row keeps its rhythm. Decorative: what the state
 * means is carried by the avatar's accessible name, not by this drawing.
 */
export function RobotShape() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <circle cx="16" cy="2.6" r="2.2" />
      <rect x="15.1" y="4" width="1.8" height="2.6" />
      <rect x="0" y="14" width="3.2" height="8" rx="1.6" />
      <rect x="28.8" y="14" width="3.2" height="8" rx="1.6" />
      <rect x="3" y="6" width="26" height="24" rx="7" />
    </svg>
  )
}

/**
 * An agent at work, as the roster draws it: the robot in the member's colour carrying their
 * initials. `name` is the member (initials + colour); `label` is the full holder wording ("Alex's
 * agent (yours)") — the chip's accessible name and tooltip, so nothing is lost to the initials.
 */
export function AgentChip({ name, label }: { name: string; label: string }) {
  return (
    <span className="av bot av-chip" role="img" aria-label={label} title={label} style={{ color: colorFromName(name) }}>
      <RobotShape />
      <span>{initials(name)}</span>
    </span>
  )
}
